import { createContext, useContext, useState, useEffect } from "react";
import { useSiteContent } from "./SiteContentContext";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
    const { content } = useSiteContent();
    const [currency, setCurrency] = useState(() => localStorage.getItem("tc-currency") || "EUR");
    const rate = content.currency_lek_per_eur || 100;

    useEffect(() => {
        localStorage.setItem("tc-currency", currency);
    }, [currency]);

    const format = (euroPrice) => {
        if (euroPrice === null || euroPrice === undefined || Number.isNaN(euroPrice)) return "—";
        const n = Number(euroPrice);
        if (currency === "LEK") {
            const lek = Math.round(n * rate);
            return `${lek.toLocaleString()} Lek`;
        }
        return `€${n.toFixed(2)}`;
    };

    // Returns both currencies — useful in Sales views regardless of toggle
    const formatBoth = (euroPrice) => {
        if (euroPrice === null || euroPrice === undefined || Number.isNaN(euroPrice)) {
            return { eur: "—", lek: "—" };
        }
        const n = Number(euroPrice);
        return {
            eur: `€${n.toFixed(2)}`,
            lek: `${Math.round(n * rate).toLocaleString()} Lek`,
        };
    };

    const symbol = currency === "LEK" ? "Lek" : "€";

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency, rate, format, formatBoth, symbol }}>
            {children}
        </CurrencyContext.Provider>
    );
}

export function useCurrency() {
    const ctx = useContext(CurrencyContext);
    if (!ctx) throw new Error("useCurrency must be inside CurrencyProvider");
    return ctx;
}
